module.exports = __webpack_public_path__ + "img/flottbygge1.4d6930db.jpg";